import DataProvider from '@app/model/_common/DataProvider';
import React from 'react';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';


const placeholderIcon = (name: string) => <div
	className="flex items-center rounded-sm bg-gray-100 px-0.5 py-0.5 text-gray-900 ring-1 ring-inset ring-gray-700/20"
	data-tooltip-id="image-tooltip"
	data-tooltip-content={name}>
	<BuildingOfficeIcon className="block h-4 w-4 text-gray-500" />
</div>;

export const PROVIDER_DATA = {
	[DataProvider.BOOKING]: {
		name: 'Booking',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip" data-tooltip-content="Booking"
							 src={'/assets/img/logos/bookingcom-icon.svg'} alt="Booking" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
							 src="/assets/img/logos/bookingcom.svg" alt="Booking"
							 title="Booking" />,
	},
	[DataProvider.HOTELS_COM]: {
		name: 'Hotels.com',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="Hotels.com" src={'/assets/img/logos/hotelscom-icon.svg'}
							 alt="Hotels.com" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
							 src="/assets/img/logos/expedia.svg" alt="Expedia"
							 title="Expedia" />,
	},
	[DataProvider.AGODA]: {
		name: 'Agoda',
		icon: <img className="block h-6 w-auto" data-tooltip-id="image-tooltip" data-tooltip-content="Agoda"
							 src={'/assets/img/logos/agoda-icon.svg'} alt="Agoda" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,

	},
	[DataProvider.EXPEDIA]: {
		name: 'Expedia',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="Expedia" src={'/assets/img/logos/expedia-icon.svg'}
							 alt="Expedia" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
							 src="/assets/img/logos/expedia.svg" alt="Expedia"
							 title="Expedia" />,
	},
	[DataProvider.HOLIDAYCHECK]: {
		name: 'HolidayCheck',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="HolidayCheck" src={'/assets/img/logos/holidaycheck-icon.svg'}
							 alt="HolidayCheck" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
							 src="/assets/img/logos/holidaycheck.svg" alt="HolidayCheck"
							 title="HolidayCheck" />,
	},
	[DataProvider.TRAVELSUPERMARKET]: {
		name: 'TravelSupermarket',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
							 data-tooltip-content="TravelSupermarket" src={'/assets/img/logos/travelsupermarket-icon.svg'}
							 alt="TravelSupermarket" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
							 src="/assets/img/logos/travelsupermarket.svg" alt="TravelSupermarket"
							 title="TravelSupermarket" />,
	},
	[DataProvider.TUIUK]: {
		name: 'TUI UK',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
		           data-tooltip-content="TUI UK" src={'/assets/img/logos/tui-icon.svg'}
		           alt="TUI UK" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
		                                                                        src="/assets/img/logos/tui.svg" alt="TUI UK"
		                                                                        title="TUI UK" />,
	},
	[DataProvider.TUIDE]: {
		name: 'TUI DE',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
		           data-tooltip-content="TUI DE" src={'/assets/img/logos/tui-icon.svg'}
		           alt="TUI DE" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
		                                                                        src="/assets/img/logos/tui.svg" alt="TUI DE"
		                                                                        title="TUI DE" />,
	},
	[DataProvider.JET2]: {
		name: 'Jet2',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
		           data-tooltip-content="Jet 2" src={'/assets/img/logos/jet2holidays-icon.svg'}
		           alt="Jet 2" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <img className={className}
		                                                                        src="/assets/img/logos/jet2holidays.svg" alt="Jet 2"
		                                                                        title="Jet 2" />,
	},
	[DataProvider.GOOGLE]: {
		name: 'Google',
		icon: undefined,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.TRIP_ADVISOR]: {
		name: 'TripAdvisor',
		icon: undefined,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.TRIP_COM]: {
		name: 'Trip.com',
		icon: undefined,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.BRAND_COM]: {
		name: 'Brand.com',
		icon: <div
			className="flex items-center rounded-sm bg-gray-100 px-0.5 py-0.5 text-gray-900 ring-1 ring-inset ring-gray-700/20">
			<BuildingOfficeIcon className="block h-4 w-4 text-gray-500" /></div>,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.PRICELINE]: {
		name: 'Priceline',
		icon: undefined,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.WEBHOTELIER]: {
		name: 'Webhotelier',
		icon: undefined,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
	[DataProvider.HILTON]: {
		name: 'Hilton',
		icon: undefined,
		logo: undefined,
	},
	[DataProvider.AIRBNB]: {
		name: 'Airbnb',
		icon: <img className="block h-5 w-auto" data-tooltip-id="image-tooltip"
					 data-tooltip-content="Airbnb" src={'/assets/img/logos/airbnb-icon.svg'}
					 alt="Airbnb" />,
		logo: (className: string = 'block h-5 w-auto relative top-0.5') => <div/>,
	},
};

export const findProviderData = (provider: DataProvider) => PROVIDER_DATA[provider];
